import React from "react";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import moment from "moment";

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Avatar from '@material-ui/core/Avatar';
import { lightBlue } from '@material-ui/core/colors';
import TablePagination from "@material-ui/core/TablePagination";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Box from '@material-ui/core/Box';

const headCells = [
  { id: "catalogAdId", disablePadding: true, label: "Catalog Ad Id" },
  { id: "adTitle", disablePadding: true, label: "Ad Title" },
  { id: "businessInfo", disablePadding: true, label: "Business ID / Business Name" },
  { id: "products", disablePadding: true, label: "Products" },
  { id: "activeDate", disablePadding: true, label: "Active Date" },
  { id: "role", disablePadding: true, label: "Role" },
  { id: "noticeType", disablePadding: true, label: "Notice Type" },
  { id: "preview", disablePadding: true, label: "Preview" },
  { id: "isActive", disablePadding: true, label: "Status" },
  { id: "edit", disablePadding: true, label: "" },
  { id: "delete", disablePadding: true, label: "" },
];

function EnhancedTableHead(props) {
  const { classes } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          // Apply specific styles based on column
          let cellClass = classes.tableCellHeader;
          if (headCell.id === "businessInfo") {
            cellClass = classes.tableCellBusiness;
          } else if (headCell.id === "activeDate") {
            cellClass = classes.tableCellActiveDate;
          } else if (headCell.id === "preview") {
            cellClass = classes.tableCellSmall11;
          } else if (headCell.id === "edit" || headCell.id === "delete") {
            cellClass = classes.tableCellActionButton;
          } else {
            cellClass = classes.tableCellCompact;
          }
          return (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              className={cellClass}
            >
              {headCell.label}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  return (
    <Toolbar style={{ paddingLeft: "16px" }}>
      <Typography
        className={classes.title}
        variant="subtitle2"
        id="tableTitle"
        component="div"
      >
        Catalog Ads ({props.totalCount})
      </Typography>


    </Toolbar>
  );
};
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },

  table: {
    width: "100%",
    tableLayout: "auto"
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  tableCellCompact: {
    fontSize: "12px",
    padding: "4px 6px",
    overflow: "hidden",
    wordWrap: "break-word",
    maxWidth: "80px",
    minWidth: "60px",
    whiteSpace: "normal",
  },
  tableCellHeader: {
    fontSize: "12px",
    padding: "8px 6px",
    fontWeight: "bold",
  },
  tableCellBusiness: {
    fontSize: "12px",
    padding: "8px 12px",
    overflow: "hidden",
    wordWrap: "break-word",
    maxWidth: "180px",
    minWidth: "160px",
    whiteSpace: "normal",
  },
  tableCellActiveDate: {
    fontSize: "12px",
    padding: "8px 12px",
    maxWidth: "180px",
    minWidth: "150px",
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
  tableCellSmall111: {
    fontSize: "12px",
    padding: "4px 6px",
    maxWidth: "80px",
    minWidth: "60px",
  },
  tableRow: {
    // cursor: 'pointer'
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  customImageContainerPreview: {
    height: "100%",
    width: "100%"
  },
  lightBlue: {
    backgroundColor: lightBlue[50],
    width: theme.spacing(4),
    height: theme.spacing(4),
    cursor: 'pointer'
  },
  tableCellSmall11: {
    fontSize: "13px",
    padding: "8px 4px",
    textAlign: 'center',
    maxWidth: 160,
    minWidth: 150,
    width: 160,
  },
  tableCellActionButton: {
    fontSize: "12px",
    padding: "4px 2px",
    textAlign: 'center',
    maxWidth: 50,
    minWidth: 40,
    width: 50,
  },
  tableCellSmall21: {
    fontSize: "13px",
    padding: "8px 12px",
    textAlign: 'left',
    maxWidth: "300px",
    minWidth: "200px",
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
  imageCarousel: {
    position: 'relative',
    width: '140px',
    height: '70px',
    overflow: 'hidden',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  carouselImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    transition: 'opacity 0.5s ease-in-out',
  },
  carouselImageActive: {
    opacity: 1,
  },
  tableCellStatus: {
    fontSize: "12px",
    padding: "4px 6px",
    overflow: "hidden",
    wordWrap: "break-word",
    minWidth: "120px",
    whiteSpace: "nowrap",
  },
}));

// Image Carousel Component
const ImageCarousel = ({ photos, onClick }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const classes = useStyles();

  // Normalize photos to array format
  const getPhotoArray = () => {
    if (!photos) return [];
    if (Array.isArray(photos)) return photos;
    if (photos.path) return [photos];
    return [];
  };

  const photoArray = getPhotoArray();

  React.useEffect(() => {
    if (photoArray.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % photoArray.length);
    }, 3000); // Auto-scroll every 3 seconds

    return () => clearInterval(interval);
  }, [photoArray.length]);

  if (photoArray.length === 0) {
    return (
      <Avatar className={classes.lightBlue}>
        <VisibilityIcon color="action" />
      </Avatar>
    );
  }

  if (photoArray.length === 1) {
    const singlePhoto = photoArray[0];
    const photoPath = singlePhoto?.path || singlePhoto;
    return (
      <Box
        className={classes.imageCarousel}
        onClick={onClick}
      >
        <img
          src={photoPath}
          alt="Catalog Ad"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
    );
  }

  // Multiple images - show carousel
  return (
    <Box
      className={classes.imageCarousel}
      onClick={onClick}
    >
      {photoArray.map((photo, index) => {
        const photoPath = photo?.path || photo;
        return (
          <img
            key={index}
            src={photoPath}
            alt={`Catalog Ad ${index + 1}`}
            className={`${classes.carouselImage} ${index === currentIndex ? classes.carouselImageActive : ''
              }`}
          />
        );
      })}
    </Box>
  );
};

export default function CatalogAdTable(props) {
  const classes = useStyles();
  const [previewOpen, setPreviewOpen] = React.useState(false);
  const [previewData, setPreviewData] = React.useState(null);

  const handleChangePage = (event, newPage) => {
    props.setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    props.setRowsPerPage(parseInt(event.target.value, 10));
    props.setPage(0);
  };

  const handlePreviewOpen = (row) => {
    setPreviewData(row);
    setPreviewOpen(true);
  };

  const handlePreviewClose = () => {
    setPreviewOpen(false);
    setPreviewData(null);
  };

  const headers = [
    { key: "catalogAdId", disablePadding: true, label: "Catalog Ad Id" },
    { key: "adTitle", disablePadding: true, label: "Ad Title" },
    { key: "businessInfo", disablePadding: true, label: "Business ID / Business Name" },
    { key: "toggleMaintenance", disablePadding: true, label: "Active Date" },
    { key: "role", disablePadding: true, label: "Role" },
    { key: "noticeType", disablePadding: true, label: "Notice Type" },
  ];


  const emptyRows =
    props.rowsPerPage -
    Math.min(
      props.rowsPerPage,
      props.totalCount - props.page * props.rowsPerPage
    );
  let data = [];
  props.exportToExcel &&
    props.exportToExcel.forEach((element) => {
      let item = element;
      // Use businessIdString (actual business ID) or populated businessId.businessId, not MongoDB _id
      let displayBusinessId = "NA";
      if (item.businessIdString && item.businessIdString != null && item.businessIdString !== "") {
        displayBusinessId = item.businessIdString;
      } else if (item.businessId) {
        if (typeof item.businessId === 'object' && item.businessId.businessId) {
          displayBusinessId = item.businessId.businessId;
        } else if (typeof item.businessId === 'string' && item.businessId.length === 24) {
          // This is a MongoDB _id, we don't want to show it
          displayBusinessId = "NA";
        }
      }
      // Get business name from populated businessId or from item.businessName
      let displayBusinessName = item.businessName || (item.businessId && typeof item.businessId === 'object' ? item.businessId.businessName : null) || "NA";
      item.businessInfo = `${displayBusinessId} / ${displayBusinessName}`;

      // Format product names
      if (item.productIds && Array.isArray(item.productIds) && item.productIds.length > 0) {
        const productNames = item.productIds
          .filter(p => p && p.service)
          .map(p => p.service)
          .join(', ');
        item.products = productNames || "NA";
      } else {
        item.products = "NA";
      }

      // Fix actionDate error - check if toggleMaintenance exists and has enough elements
      if (item.toggleMaintenance && Array.isArray(item.toggleMaintenance) && item.toggleMaintenance.length > 0) {
        if (item.isActive === true) {
          const lastItem = item.toggleMaintenance[item.toggleMaintenance.length - 1];
          item.toggleMaintenance = lastItem && lastItem.actionDate
            ? moment(lastItem.actionDate).format("[From:] DD-MMM-YYYY hh:mm A")
            : "NA";
        } else {
          const secondLastItem = item.toggleMaintenance.length >= 2 ? item.toggleMaintenance[item.toggleMaintenance.length - 2] : null;
          const lastItem = item.toggleMaintenance[item.toggleMaintenance.length - 1];
          if (secondLastItem && secondLastItem.actionDate && lastItem && lastItem.actionDate) {
            item.toggleMaintenance = `${moment(secondLastItem.actionDate).format("[From:] DD-MMM-YYYY hh:mm A")} ${moment(lastItem.actionDate).format("[To:] DD-MMM-YYYY hh:mm A")}`;
          } else {
            item.toggleMaintenance = "NA";
          }
        }
      } else {
        item.toggleMaintenance = "NA";
      }
      data.push(item);
    });

  if (props.activeShopper) {
    var activeShopperRecordExists = props.activeShopper
  }
  if (props.activeBusiness) {
    var activeBusinessRecordExists = props.activeBusiness
  }
  return (

    <div className={classes.root}>

      <Paper className={classes.paper}>
        <EnhancedTableToolbar
          headers={headers}
          totalCount={props.totalCount}
          data={data}
          showDownloadIcon={props.showDownloadIcon}
          fetchExportToExcel={props.fetchExportToExcel}

        />
        {props.data && props.data.length > 0 ?
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="small"
              aria-label="enhanced table"
              totalCount={props.totalCount}
              data={data}
            >
              <EnhancedTableHead
                classes={classes}
                order={props.order}
                orderBy={props.orderBy}
                rowCount={props.totalCount}

              />

              <TableBody>
                {props.data && props.data.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      className={classes.tableRow}
                      tabIndex={-1}
                      key={index}
                    >
                      <TableCell
                        align="left"
                        className={classes.tableCellCompact}
                        style={{ fontSize: "12px" }}
                      >
                        {row.catalogAdId && row.catalogAdId != null ? row.catalogAdId : "NA"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellCompact}
                      >
                        <Typography style={{ fontSize: "12px" }}>{row.adTitle && row.adTitle != null ? row.adTitle : "NA"}</Typography>
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellBusiness}
                        style={{ fontSize: "12px" }}
                      >
                        {(() => {
                          // Prioritize businessIdString (contains the actual business ID like "DA315677", not MongoDB _id)
                          // If businessId is populated as an object, get its businessId field
                          let displayBusinessId = "NA";
                          if (row.businessIdString && row.businessIdString != null && row.businessIdString !== "") {
                            displayBusinessId = row.businessIdString;
                          } else if (row.businessId) {
                            if (typeof row.businessId === 'object' && row.businessId.businessId) {
                              // businessId is populated, get the actual businessId string
                              displayBusinessId = row.businessId.businessId;
                            } else if (typeof row.businessId === 'string' && row.businessId.length === 24) {
                              // This is a MongoDB _id, we don't want to show it
                              displayBusinessId = "NA";
                            }
                          }
                          // Get business name from populated businessId or from row.businessName
                          let displayBusinessName = row.businessName || (row.businessId && typeof row.businessId === 'object' ? row.businessId.businessName : null) || "NA";
                          // Don't display MongoDB _id - only show actual businessId string
                          return `${displayBusinessId} / ${displayBusinessName}`;
                        })()}
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellCompact}
                      >
                        {(() => {
                          if (row.productIds && Array.isArray(row.productIds) && row.productIds.length > 0) {
                            const productNames = row.productIds
                              .filter(p => p && p.service)
                              .map(p => p.service);
                            if (productNames.length > 0) {
                              return (
                                <Typography variant="body2" style={{ fontSize: "12px" }}>
                                  {productNames.join(', ')}
                                </Typography>
                              );
                            }
                          }
                          return "NA";
                        })()}
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellActiveDate}>
                        {row.toggleMaintenance && Array.isArray(row.toggleMaintenance) && row.toggleMaintenance.length > 0 ? (
                          row.isActive ? (
                            (() => {
                              const lastItem = row.toggleMaintenance[row.toggleMaintenance.length - 1];
                              return lastItem && lastItem.actionDate ? (
                                <Typography style={{ fontSize: "12px" }}>
                                  {moment(lastItem.actionDate).format("[From:] DD-MMM-YYYY hh:mm A")} <br></br>
                                </Typography>
                              ) : "NA";
                            })()
                          ) : (
                            (() => {
                              const secondLastItem = row.toggleMaintenance.length >= 2 ? row.toggleMaintenance[row.toggleMaintenance.length - 2] : null;
                              const lastItem = row.toggleMaintenance[row.toggleMaintenance.length - 1];
                              if (secondLastItem && secondLastItem.actionDate && lastItem && lastItem.actionDate) {
                                return (
                                  <Typography style={{ fontSize: "12px" }}>
                                    {moment(secondLastItem.actionDate).format("[From:] DD-MMM-YYYY hh:mm A")}
                                    <br></br>
                                    {moment(lastItem.actionDate).format("[To:] DD-MMM-YYYY hh:mm A")}
                                  </Typography>
                                );
                              }
                              return "NA";
                            })()
                          )
                        ) : (
                          "NA"
                        )}
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellCompact}
                        style={{ fontSize: "12px" }}
                      >
                        {row.role && row.role != null ? row.role : "NA"}
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellCompact}
                        style={{ fontSize: "12px" }}
                      >
                        {row.noticeType && row.noticeType != null ? row.noticeType : "NA"}
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellSmall11} scope="row">
                        <Box style={{ display: 'flex', justifyContent: 'center' }}>
                          <ImageCarousel
                            photos={row.photo}
                            onClick={() => {
                              if (row.photo &&
                                ((Array.isArray(row.photo) && row.photo.length > 0) ||
                                  (!Array.isArray(row.photo) && row.photo.path))) {
                                handlePreviewOpen(row);
                              }
                            }}
                          />
                        </Box>
                      </TableCell>
                      <TableCell align="left" className={classes.tableCellStatus}>
                        <FormControlLabel
                          control={
                            <Switch
                              size="small"
                              checked={row.isActive}
                              onChange={() => props.handleToggleSwitch(row)}
                              color="primary"
                              disabled={(row.role === "Business" && activeBusinessRecordExists && activeBusinessRecordExists.length > 0 && row.isActive !== true) || (row.role === "Shopper" && activeShopperRecordExists && activeShopperRecordExists.length > 0 && row.isActive !== true) || (row.role === "Both" && ((activeBusinessRecordExists && activeBusinessRecordExists.length > 0) || (activeShopperRecordExists && activeShopperRecordExists.length > 0)) && row.isActive !== true) ? true : false}
                            />
                          }
                          style={{ fontSize: "8px", color: row.isActive ? 'black' : 'red', margin: 0 }}
                          label={row.isActive ? 'Active' : 'Inactive'}
                        />
                      </TableCell>
                      <TableCell className={classes.tableCellActionButton} scope="row" >
                        <IconButton
                          style={{
                            float: "right",
                            padding: "4px"
                          }}
                          onClick={() => props.handleCatalogAdEditOpen(row)}
                        >
                          <Avatar className={classes.lightBlue} style={{ width: "24px", height: "24px" }}>
                            <EditIcon color="action" style={{ fontSize: "16px" }} />
                          </Avatar>
                        </IconButton>
                      </TableCell>
                      <TableCell className={classes.tableCellActionButton} scope="row">
                        <IconButton
                          style={{
                            float: "right",
                            padding: "4px"
                          }}
                          onClick={() => { props.handleCatalogAdDeleteOpen(row) }}
                        >
                          <Avatar className={classes.lightBlue} style={{ width: "24px", height: "24px" }}>
                            <DeleteIcon color="action" style={{ fontSize: "16px" }} />
                          </Avatar>
                        </IconButton>
                      </TableCell>

                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 33 * emptyRows }}>
                    <TableCell colSpan={11} />
                  </TableRow>
                )}
              </TableBody>


            </Table>
          </TableContainer>
          : <Typography style={{ margin: "0px 400px 0px 400px" }}>No Records Available</Typography>}
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 20, 25, 30, 50]}
          component="div"
          count={props.totalCount}
          rowsPerPage={props.rowsPerPage}
          page={props.page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}

        />
      </Paper>
      <Dialog
        open={previewOpen}
        onClose={handlePreviewClose}
        maxWidth="md"
        fullWidth
        aria-labelledby="preview-dialog-title"
        aria-describedby="preview-dialog-description"
      >
        <DialogTitle id="preview-dialog-title">Preview Catalog Ad</DialogTitle>
        <DialogContent>
          {previewData && (
            <div>
              <Typography variant="h6" gutterBottom>
                {previewData.adTitle || "NA"}
              </Typography>
              {previewData.noticeType === "With Image" ? (
                <div>
                  {previewData.photo && (
                    Array.isArray(previewData.photo) && previewData.photo.length > 0 ? (
                      <div>
                        {previewData.photo.map((photo, index) => (
                          <img
                            key={index}
                            src={photo.path}
                            alt={photo.title || "Catalog Ad"}
                            style={{ maxWidth: "100%", height: "auto", marginBottom: "16px", cursor: "pointer" }}
                            onClick={() => window.open(photo.path, '_blank')}
                          />
                        ))}
                      </div>
                    ) : previewData.photo?.path ? (
                      <img
                        src={previewData.photo.path}
                        alt="Catalog Ad"
                        style={{ maxWidth: "100%", height: "auto", marginBottom: "16px", cursor: "pointer" }}
                        onClick={() => window.open(previewData.photo.path, '_blank')}
                      />
                    ) : null
                  )}
                  <Typography variant="body1">
                    {previewData.notificationBody || "NA"}
                  </Typography>
                </div>
              ) : (
                <div>
                  {previewData.photo && (
                    Array.isArray(previewData.photo) && previewData.photo.length > 0 ? (
                      <div>
                        {previewData.photo.map((photo, index) => (
                          <img
                            key={index}
                            src={photo.path}
                            alt={photo.title || "Catalog Ad Icon"}
                            style={{ maxWidth: "100px", height: "auto", marginBottom: "16px", cursor: "pointer" }}
                            onClick={() => window.open(photo.path, '_blank')}
                          />
                        ))}
                      </div>
                    ) : previewData.photo?.path ? (
                      <img
                        src={previewData.photo.path}
                        alt="Catalog Ad Icon"
                        style={{ maxWidth: "100px", height: "auto", marginBottom: "16px", cursor: "pointer" }}
                        onClick={() => window.open(previewData.photo.path, '_blank')}
                      />
                    ) : null
                  )}
                  <Typography variant="body1">
                    {previewData.message || "NA"}
                  </Typography>
                </div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePreviewClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

